import { createContext, useContext, type ReactNode } from "react";

/**
 * When true, descendant SignedOutputImage instances skip IntersectionObserver
 * and sign/load immediately (PDF print root).
 */
export const ArtworkEagerImagesContext = createContext(false);

export function ArtworkEagerImagesProvider({
  value,
  children,
}: {
  value: boolean;
  children: ReactNode;
}) {
  return (
    <ArtworkEagerImagesContext.Provider value={value}>
      {children}
    </ArtworkEagerImagesContext.Provider>
  );
}

export function useArtworkEagerImages(): boolean {
  return useContext(ArtworkEagerImagesContext);
}
